const React = require('react');
const map = require('mn-utils/map');

const {DisplayDataMerchant} = require('../../../../../dumb/DisplayData');

const DataBlock = require('./DataBlock');

module.exports = (props) => {
  const data = props.data || {};
  const dataArr = [
    {
      title: 'App Url',
      value: (
        <DisplayDataMerchant className="fhaS">
          {data.name}
        </DisplayDataMerchant>
      ),
    },
    {
      title: 'API Token',
      value: (
        <DisplayDataMerchant className="fhaS">
          {data.api_token}
        </DisplayDataMerchant>
      ),
    },
    {
      title: 'Status',
      value: (
        <div className={`cFFBF43.inactive c2CE889.active fw700 ${data.enabled ? 'active' : 'inactive'}`}>
          {data.enabled ? 'Active' : 'Inactive'}
        </div>
      ),
    }
  ];

  return (
    <div className="wmax670 layoutRow fxwWrap mh-25 mt10">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/3 w1/2@m w@m2 mt25 ph25">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
